import React from 'react';
import { Navigate } from 'react-router-dom';
import { CMS_ROUTES } from '../../constants';
import { useAuth } from '../provider/auth-context';

const AdminRoute = ({ element: Element, ...rest }) => {
  const {user} = useAuth();  
  return user && user.admin ? <Element {...rest} /> : <Navigate to={CMS_ROUTES.LOGIN} />;
};

export default AdminRoute;
